'use strict';

goog.provide("Ntry.StudyCodingpartyHint");

Ntry.StudyCodingpartyHint = function() {
    this._view = Ntry.interfaceManager.getDom('ntryHintArea');
    this._currentIndex = 0;
    this._hint;
    this.createDom();
    this._popupHelper = new Entry.popupHelper(true);
    Ntry.addEventListener('changeMode', this, this.setMode);
    Ntry.addEventListener('hideIntro', this, this.hideIntro);
    this._mode = 0;
    this.operationCount = 0;
    this.hideIntroCount = 0;
};

(function(p){

    p.createDom = function () {
        var that = this;
        var parent = this._view;

        this._blockHintView = Ntry.createElement('div', parent, null, 'ntryBlockHintArea');
        this._textHintView = Ntry.createElement('div', parent, null, 'ntryTextHintArea');

        var textHeader = Ntry.createElement('div', this._textHintView, null, 'ntryTextHintHeader');
        this._textHintView.ntryRemove();
        var textHintNumber = Ntry.createElement('span', textHeader, null, 'ntryTextHintQuestion');
        textHintNumber.textContent = Lang.Menus.goals;
        this._textHintContainer = Ntry.createElement('span', textHeader, null, 'ntryTextHintContainer');

        var buttonArea = Ntry.createElement('div', this._textHintView, null, 'ntryHintButtonArea');
        this._operationBtn = Ntry.createElement('button', buttonArea, null, 'ntryHintOperationBtn ntryHintButton');
        this._commandBtn = Ntry.createElement('button', buttonArea, null, 'ntryHintCommandBtn ntryHintButton');
        this._objectBtn = Ntry.createElement('button', buttonArea, null, 'ntryHintObjectBtn ntryHintButton');
        this._operationBtn.bindOnClick(function(){
            that._popupHelper.show('operation');
        });
        this._commandBtn.bindOnClick(function(){
            that._popupHelper.show('command');
        });

        this._objectBtn.bindOnClick(function(){
            that._popupHelper.show('object');
        });

        this._operationBtn.textContent = Lang.Menus.instructions;
        this._commandBtn.textContent = Lang.Menus.command_guide;
        this._objectBtn.textContent = Lang.Menus.object_info;

        var header = Ntry.createElement('div', this._blockHintView, null, 'ntryHintHeader');

        this._hintNumber = Ntry.createElement('span', header, null, 'ntryHintQuestionNumber');
        this._hintNumber.textContent = Lang.Menus.goals;

        this._hintContainer = Ntry.createElement('span', header, null, 'codingpartyHintContainer');
        this._hintContainer.addClass('ntryHintContent');

        this._hintThumbnail = Ntry.createElement('div', this._blockHintView, null, 'ntryHintThumbnail');

        this._hintModal = Ntry.createElement('div', this._blockHintView, null, 'ntryHintModal');
        this._hintModal.ntryRemove();

        this._hintModal.bindOnClick(function(e) {
            if (e.target == this)
                that._hintModal.ntryRemove();
        });

        var modalContainer = Ntry.createElement('div', this._hintModal, null, 'ntryHintModalContainer');
        var modalTitle = Ntry.createElement('div', modalContainer, null, 'ntryHintModalTitle')
        var modalText = Ntry.createElement('span', modalTitle, null, 'ntryModalTitleText');
        modalText.innerHTML = Lang.Menus.jr_help;
        this._closeButton = Ntry.createElement('span', modalTitle, null, 'ntryHintModalCloseButton');
        this._modalContent = Ntry.createElement('div', modalContainer, null, 'ntryHintModalContent');
    };

    p.update = function() {};

    p.loadConfig = function () {
        this.position();

        this._hint = Ntry.configManager.getConfig('intro');
        this._popups = Ntry.configManager.getConfig('popups');

        if(this._popups) {
            this._textHintContainer.textContent = this._popups.objective;
            if(!('operation' in this._popups)) {
                this._operationBtn.hidden = true;
            } else {
                this.setOperationPopup();
            }

            if(!('command' in this._popups)) {
                this._commandBtn.hidden = true;
            } else {
                this.setCommandPopup();
            }

            if(!('object' in this._popups)) {
                this._objectBtn.hidden = true;
            } else {
                this.setObjectPopup();
            }
        } else {
            this._objectBtn.hidden = true;
            this._commandBtn.hidden = true;
            this._operationBtn.hidden = true;
        }

        this.setMode(this.mode);
        this.fillHintContent();
    };

    p.setMode = function (mode) {
        mode = mode === undefined ? 0 : mode;
        mode = isNaN(mode) ? mode.boardType : mode;
        this._mode = Number(mode) || 0;
        switch(this._mode) {
            case Entry.Workspace.MODE_VIMBOARD:
                this._blockHintView.hidden = true;
                this._textHintView.hidden = false;
                this._textHintView.ntryShow();
                break;
            case Entry.Workspace.MODE_BOARD:
                this._textHintView.hidden = true;
                this._textHintView.ntryRemove();
                this._blockHintView.hidden = false;
                break;
        }
    };

    p.hideIntro = function (mode) {
        mode = mode === undefined ? 0 : mode;
        mode = isNaN(mode) ? mode.boardType : mode;
        this._mode = Number(mode) || 0;
        if(mode === Entry.Workspace.MODE_VIMBOARD) {
            this.hideIntroCount++;
            this.showOperationPopup();
        }
    }

    p.showOperationPopup = function () {
        if(this.hideIntroCount > 0 && this.operationCount === 0 &&
            (this._mode === Entry.Workspace.MODE_VIMBOARD) && this._popupHelper.hasPopup('operation')) {
            this._popupHelper.show('operation');
            this.operationCount++;
        }
    };

    p.fillHintContent = function () {
        var hint = this._hint,
            content = this._hintContainer;

        content.innerHTML = hint.content;

        if (hint.image) {
            var image = hint.image;


            this._hintThumbnail.removeClasses();
            this._hintThumbnail.addClass("cpartyHintThumbnail");
            this._hintThumbnail.addClass("cpartyHintThumbnail_"+image);
            if (image == 1 || image == 6 || image == 11)
                this._hintThumbnail.addClass(Lang.type);


            this._modalContent.removeClasses();
            this._modalContent.addClass("cpartyHintModalImage");
            this._modalContent.addClass("cpartyHintModalImage_"+image);
            if (image == 1 || image == 6 || image == 11)
                this._modalContent.addClass(Lang.type)

            var self = this;
            this._hintThumbnail.bindOnClick(function() {
                self._hintModal.ntryShow();
            });

            this._closeButton.bindOnClick(function() {
                self._hintModal.ntryRemove();
            });
        }
    };

    p.position = function() {
        var gridSize = Ntry.configManager.getConfig("gridSize");
        var tileSize = Ntry.configManager.getConfig("tileSize");
        var engineHeight = $(Ntry.interfaceManager.getDom('ntryEngine')).height();
        var adjust = gridSize.height > 3 ? 1/gridSize.width*7 : 1;
        var top = gridSize.height*tileSize*adjust + engineHeight + 13;
        $(this._view).css('top', top+'px');
    };

    p.setOperationPopup = function() {
        var setting = Ntry.OperationPopup;
        setting.title = this._popups.operation.title;
        setting.content = this._popups.operation.content;
        this._popupHelper.addPopup('operation', setting);
    }

    p.setCommandPopup = function() {
        var setting = Ntry.CommandPopup;
        setting.title = this._popups.command.title;
        setting.content = this._popups.command.content;
        this._popupHelper.addPopup('command', setting);
    }
    p.setObjectPopup = function() {
        var setting = Ntry.ObjectPopup;
        setting.title = this._popups.object.title;
        setting.popupType = this._popups.object.popupType;
        setting.object = this._popups.object.object;
        this._popupHelper.addPopup('object', setting);
    }

})(Ntry.StudyCodingpartyHint.prototype);


